import { render, staticRenderFns } from "./MapaMundial.vue?vue&type=template&id=231bed16&scoped=true"
import script from "./MapaMundial.vue?vue&type=script&lang=js"
export * from "./MapaMundial.vue?vue&type=script&lang=js"
import style0 from "./MapaMundial.vue?vue&type=style&index=0&id=231bed16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231bed16",
  null
  
)

export default component.exports